import React, { useState } from "react";
import { MdWaterDrop } from "react-icons/md";
import { HiLocationMarker, HiOutlineViewGridAdd } from "react-icons/hi";
import { GiScubaTanks } from "react-icons/gi";
import { FaSyringe, FaVenus } from "react-icons/fa";
import { FiSettings } from "react-icons/fi";
import style from "./Completed.module.scss";
import Button from "@mui/material/Button";
import {
  processOrder,
  processScheduledOrder,
} from "../../../redux/orders/actions/orders.actions";
import { constructOrderDate } from "../../../helper/DateFormatter";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmationModal } from "../../Modal/ConfirmationModal";
import StockbankInstruction from "../../orderInstruction/stockbankInstruction";
import BloodInstruction from "../../orderInstruction/BloodInstruction";
import OxygenScheduled from "../../orderInstruction/OxygenScheduled";
import { useNavigate } from "react-router-dom";
import { MdBusAlert } from "react-icons/md";
import { SyncOutlined } from "@ant-design/icons";
import Venom from "../../orderInstruction/Venom";

export const delay = (ms) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

const Schedule = ({
  order_id,
  id,
  component,
  name,
  product,
  address,
  city,
  state,
  tym,
  order_by,
  qty,
  title,
  // dispatch,
  dispatch_name,
  vendor_name,
  payment_type,
  total,
  returns,
  scheduled_date,
  order_pick,
  show,
  ...props
}) => {
  const [openModal, setopenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);

  const navigate = useNavigate();

  let userDetails;
  if (localStorage.getItem("userToken")) {
    userDetails = JSON.parse(localStorage.getItem("userToken"));
  }

  const bgColor = () => {
    if (title === "blood") return "#FDE0E0";
    if (title === "oxygen") return "#E0EFFD";
    if (title === "Quip") return "#ffd4c2";
    if (title === "Antivemon") return "#7F00";
    return "#F0FDE0";
  };

  const icons = () => {
    if (title === "blood") return <MdWaterDrop size={25} color="#B70303" />;
    if (title === "oxygen") return <GiScubaTanks size={25} color="#2457C5" />;
    if (title === "Quip") return <FiSettings size={25} color="#c7460f" />;
    if (title === "Antivemon") return <FaVenus size={25} color="#7F00FF" />;
    return <FaSyringe size={25} color="#78A55A" />;
  };

  const colors = () => {
    if (title === "blood") return "#B70303";
    if (title === "oxygen") return "#2457C5";
    if (title === "Quip") return "#c7460f";
    if (title === "Antivemon") return "#7F00FF";
    return "#78A55A";
  };

  const dispatch = useDispatch();

  // const { closed } = useSelector((state) => state.orderReducer)

  const data = {
    title: title === "blood" ? "Blood" : title,
    order_by: order_by,
    bloodtype: product,
  };

  const scheduleData = {
    title: title === "blood" ? "Blood" : title,
    order_id: order_id,
  };

  const processHandler = async () => {
    dispatch(processOrder(data));
    setLoading(true);
    await delay(3000);
    setLoading(false);
    if (title === "oxygen") {
      navigate(`/process-schedule/${order_id}`, { state: data });
    }
  };

  const processScheduleHandler = async () => {
    dispatch(processScheduledOrder(scheduleData));
    setProcessing(true);
    await delay(3000);
    setProcessing(false);

    navigate(`/ongoing-orders`);
  };

  const modalPerformance = () => {
    if (title === "StockBank") {
      navigate(`/stockbank/${order_id}`);
    } else if (title === "Quip") {
      // setopenModal(true);
      navigate(`/quip/${order_id}`);
    } else {
      setopenModal(true);
    }
  };

  return (
    <>
      <div>
        <div className={style.container}>
          <div className={style.innerContainer}>
            <div className={style.content}>
              <div
                className={`${style.icon}`}
                style={{ background: bgColor() }}
              >
                {icons()}
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>Product Name</p>
                <p className={style.text}>{product}</p>
              </div>
            </div>

            <div className={style.content}>
              <div className={style.icon} style={{ background: bgColor() }}>
                <HiOutlineViewGridAdd size={25} color={colors()} />
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>QUANTITY</p>
                <p className={style.text}>{qty}</p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>PAYMENT TYPE</p>
                <p className={style.text}>{payment_type}</p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>TOTAL</p>
                <p className={style.text}>{total}</p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>SCHEDULED DATE</p>
                <p className={style.text}>{scheduled_date}</p>
              </div>
            </div>
            <div className={style.content}>
              <div className="d-flex flex-column">
                <p className={style.header}>HOSPITAL NAME</p>
                <p className={style.text}>{name}</p>
              </div>
            </div>
            <div className={`${style.content} ${style.address}`}>
              <div className={style.icon} style={{ background: bgColor() }}>
                <HiLocationMarker size={25} color={colors()} />
              </div>
              <div className="d-flex flex-column">
                <p className={style.header}>HOSPITAL ADDRESS</p>
                <p className={style.text}>{` ${address}, ${city}, ${state}`}</p>
              </div>

              <div>
                {returns !== null && <MdBusAlert size={25} color={colors()} />}
              </div>
            </div>

            <div className={style.content}>
              <div className="d-flex flex-column align-items-center justify-content-center">
                <Button
                  className={style.button}
                  style={{
                    border: `2px solid ${show === null ? "#ccc" : bgColor()}`,
                    color: show === null ? "#999" : colors(),
                    backgroundColor: show === null ? "#f5f5f5" : "transparent",
                    height: "2.5rem",
                    alignSelf: "center",
                    cursor: show === null ? "not-allowed" : "pointer",
                    opacity: show === null ? 0.6 : 1,
                  }}
                  onClick={show === null ? null : processScheduleHandler}
                  disabled={show === null}
                >
                  {processing ? <SyncOutlined spin /> : "PROCESS ORDER"}
                </Button>
              </div>
            </div>
          </div>
          <div className={style.bott}>
            <div className={style.time}>
              Last update :{constructOrderDate(tym)}
            </div>

            <div className={style.update} onClick={modalPerformance}>
              {loading ? <SyncOutlined spin /> : "Update Order"}
            </div>
          </div>
        </div>
      </div>

      {/* DIALOG MODAL */}
      <ConfirmationModal
        open={openModal}
        bgcolor="background.paper"
        width="80vw"
        handleClose={() => setopenModal(false)}
        closemodal={() => setopenModal(false)}
        instruction={
          title === "StockBank" ? (
            <StockbankInstruction
              status={title}
              button2={loading ? <SyncOutlined spin /> : `PROCESS ORDER`}
              orderId={order_id}
              category={title}
              headerColor={colors()}
              categoryBg={bgColor()}
              categoryColor={colors()}
              btnColor={colors()}
            />
          ) : (
            // : title === "blood" ? (
            //   <BloodInstruction
            //     button2={loading ? <SyncOutlined spin /> : `PROCESS ORDER`}
            //     orderId={`LB${order_id}`}
            //     product="Blood"
            //     bloodGroup={b_type}
            //     quantity={order_amt}
            //     vendor={name}
            //     reason={usage_info}
            //     request={personnel_name}
            //     address={address}
            //     phone={fone}
            //     payment={payment_type}
            //     time={constructOrderDate(tym)}
            //     category={title}
            //     headerColor={colors()}
            //     categoryBg={bgColor()}
            //     categoryColor={colors()}
            //     btnColor={colors()}
            //     onClickYes={processHandler}
            //   />
            // :
            // title === "Antivemon" ? (
            //   <Venom
            //     status={product || "N/A"}
            //     button2={loading ? <SyncOutlined spin /> : `PROCESS ORDER`}
            //     orderId={id}
            //     product={size}
            //     quantity={qty}
            //     payment={payment_type}
            //     hospital={name}
            //     address={`${address}, ${city}, ${state}`}
            //     category={title}
            //     time={created_at}
            //     headerColor={colors()}
            //     phone={fone}
            //     categoryBg={bgColor()}
            //     categoryColor={colors()}
            //     btnColor={colors()}
            //     onClickYes={processHandler}
            //   />
            // )
            <OxygenScheduled
              status={title}
              button2={loading ? <SyncOutlined spin /> : `PROCESS ORDER`}
              orderId={order_id || id}
              product={product}
              quantity={qty}
              payment={payment_type}
              hospital={name}
              // urgency={urgency}
              schedule_date={scheduled_date}
              // created_at={created_at}
              order_pick={order_pick}
              address={`${address}, ${city}, ${state}`}
              category={title}
              time={constructOrderDate(tym)}
              headerColor={colors()}
              // phone={fone}
              categoryBg={bgColor()}
              categoryColor={colors()}
              btnColor={colors()}
              onClickYes={processHandler}
            />
          )
        }
      />
    </>
  );
};

export default Schedule;
